<template>
  <v-menu bottom left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        small
        v-bind="attrs"
        v-on="on"
      >
        <v-icon style="color:#00000060">more_vert</v-icon>
      </v-btn>
    </template>

    <v-list flat class="item-menu-list">
      <v-list-item-group>

        <v-list-item class="item-menu-list-item" v-if="isAdmin()" @click="edit(item)">
          <v-icon class="item-menu-list-item-icon">ico-icon-edit</v-icon>
          <v-list-item-title class="item-menu-list-item-title">Editar</v-list-item-title>
        </v-list-item>
        
        <v-list-item class="item-menu-list-item" v-if="!(item.isFolder == 1) && item.url2.trim() !== ''" @click="download(item)">
          <v-icon class="item-menu-list-item-icon">ico-icon-down</v-icon>
          <v-list-item-title class="item-menu-list-item-title">Descargar</v-list-item-title>
        </v-list-item>

        <v-list-item class="item-menu-list-item" v-if="isAdmin() && !isHeritable()" v-show="!item.hidden" @click="hide(item)">
          <v-icon class="item-menu-list-item-icon">ico-icon-eye-slashed</v-icon>
          <v-list-item-title class="item-menu-list-item-title">Ocultar</v-list-item-title>
        </v-list-item>

        <v-list-item class="item-menu-list-item" v-if="isAdmin() && !isHeritable()" v-show="item.hidden" @click="unhide(item)">
          <v-icon class="item-menu-list-item-icon">ico-icon-eye</v-icon>
          <v-list-item-title class="item-menu-list-item-title">Mostrar</v-list-item-title>
        </v-list-item>

        <v-list-item class="item-menu-list-item" v-if="isAdmin() && !isSearching && !isHeritable()" @click="move(item)">
          <v-icon class="item-menu-list-item-icon">ico-icon-move</v-icon>
          <v-list-item-title class="item-menu-list-item-title">Mover</v-list-item-title>
        </v-list-item>

        <v-list-item class="item-menu-list-item" v-if="isAdmin()" @click="drop(item)">
          <v-icon class="item-menu-list-item-icon">ico-icon-trash</v-icon>
          <v-list-item-title class="item-menu-list-item-title">Eliminar</v-list-item-title>
        </v-list-item>

      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
import eventBus from '../../utils/eventBus'
import userStorage from '../../storage/userStorage'
import reportsStorage from '../../storage/reportsStorage'

export default {
  name: 'item-menu',
  methods: {
    isAdmin () {
      return userStorage.getUserInfo().userType === 'ADMIN'
    },
    isHeritable () {
      return this.item.heritable
    },
    edit (item) {
      if (item.isFolder) {
        // emit to components/dialogs/folder-form-dialog.vue
        eventBus.$emit('open-folder-form', item)
      } else {
        // emit to components/dialogs/report-form-dialog
        eventBus.$emit('open-report-form', {
          ...item,
          heritable: this.containedBy && this.containedBy.heritable,
          parentName: this.containedBy && this.containedBy.itemName,
          structureID: this.containedBy && this.containedBy.origin
        })
      }
    },
    hide (item) {
      reportsStorage.hideItem(item.itemID)
    },
    unhide (item) {
      reportsStorage.unHideItem(item.itemID)
    },
    move (item) {
      // emit to components/folders/folder-list
      eventBus.$emit('move-item', item)
      // item.isMoving = true
      // window.scrollTo(0, 75)
    },
    drop (item) {
      // emit to components/dialogs/drop-item-dialog.vue
      eventBus.$emit('drop-item', item)
    },
    download (item) {
      window.open(item.url2, '_blank')
      reportsStorage.registerView(item.itemID, 'DOWNLOAD')
    }
  },
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    isSearching: {
      type: Boolean,
      default () {
        return false
      }
    },
    containedBy: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>
<style>
.item-menu-list {
  width: 213px;
  background: #FFFFFF;
  padding: 0;
}

.item-menu-list-item {
  height: 53px;
  background: #FFFFFF;
  box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.07);
  padding: 12px 30px;
}

.item-menu-list-item-icon {
  margin-right: 13px;
  color: rgba(0, 0, 0, 0.4);
}

.item-menu-list-item-title {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.4);
}
</style>


// WEBPACK FOOTER //
// src/components/menus/item-menu.vue